module.exports = {
  getNewItem: function (data) {
    var deferred = $.Deferred();

    deferred.resolve({ color_code: data.color_code });

    return deferred.promise();
  },

  isSameModel: function (model1, model2) {
    return model1.palette === model2.palette
      && model1.color_code.toLowerCase() === model2.color_code.toLowerCase();
  }
};
